import axios from 'axios'
import { BUSCAR_ROTAS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export default function buscarRotas (codigo, pagina, registrosPorPagina, filtros, seSimples) {
  const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  let url = `${URL}/rota/empresa/${codigo}/rotas${urlFiltros}`;
  if(seSimples){
      url = url + '?simples=true';
  }
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_ROTAS,
        payload: response

      })
  );
}
